module.exports = __webpack_public_path__ + "media/common/images/badges/active/matador-c491958c09edc7210d642c74060da465.svg";